/**
 * BrandLogo — single source of truth for the PITCHD logo across the app.
 *
 * Variants:
 *   "wordmark" — icon + PITCHD text lockup (default for navbars, footers, marketing)
 *   "icon"     — just the volt-yellow P-bolt (for square containers like the favicon, mobile)
 *
 * Size accepts a CSS height value (number = px, string = any CSS unit). Width
 * is preserved by intrinsic aspect ratio via `h-X w-auto`.
 */
import { Link } from "react-router-dom";

const WORDMARK_SRC = "/brand/pitchd-wordmark.png";
const ICON_SRC = "/brand/pitchd-icon.png";

export default function BrandLogo({
  variant = "wordmark",
  size = 28,
  to = "/",
  className = "",
  showLink = true,
  alt = "PITCHD",
  "data-testid": testid = "brand-logo",
}) {
  const src = variant === "icon" ? ICON_SRC : WORDMARK_SRC;
  const heightStyle = typeof size === "number" ? `${size}px` : size;
  const img = (
    <img
      src={src}
      alt={alt}
      data-testid={testid}
      className={`w-auto block ${className}`}
      style={{ height: heightStyle }}
      draggable={false}
    />
  );
  if (!showLink) return img;
  return (
    <Link to={to} className="inline-flex items-center" aria-label="PITCHD home">
      {img}
    </Link>
  );
}
